import { Client, getUserActivityPageSessionId } from 'dsilo-ui-components';
import { clearReduxStore } from '../../store/actions'
const PUBLIC_PATH = process.env.REACT_APP_PUBLIC_PATH
    ? process.env.REACT_APP_PUBLIC_PATH + "/"
    : ""

const USERACTIVITY_EXCLUDED_PATHS = ['/useractivity/session/start', '/useractivity/session/end', '/useractivity/page/start', '/user/emailcheck'];

export const Request = (uri, options = {}) => {
    const shouldAddPageSessionId = !USERACTIVITY_EXCLUDED_PATHS.some(path => String(uri).includes(path));
    let requestOptions = { ...options };
    if (shouldAddPageSessionId) {
        const pageSessionId = getUserActivityPageSessionId();
        if (pageSessionId && String(pageSessionId).trim()) {
            requestOptions = {
                ...requestOptions,
                headers: { ...requestOptions.headers, pageSessionId }
            };
        }
    }
    return Client.request(uri, requestOptions, clearReduxStore, null, PUBLIC_PATH)
}

